import { PRIMARY_TRAVELLER_FORM_ID } from 'constants/checkout'
import createSelector from 'lib/web/createSelector'
import { getExperienceItems } from 'checkout/selectors/view/experience'

export const getPrimaryTravellerForm = createSelector(
  (state: App.State) => state.checkout.form.travellerForms,
  (forms) => forms.find(form => form.id === PRIMARY_TRAVELLER_FORM_ID),
)

export const isStandaloneExperience = createSelector(
  (state: App.State) => state.checkout.cart.items,
  getExperienceItems,
  (cartItems, experienceItems): boolean => experienceItems.length === 1 && cartItems.length === 1,
)
